var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDropbox = function SvgDropbox(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 13.266 7.06 4.603L12 13.753 4.884 9.356z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06.844 0 5.447l4.884 3.91L12 4.958zM24 5.447 16.94.844 12 4.959l7.116 4.397zM12 13.753l4.94 4.116L24 13.266l-4.884-3.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.019 14.634-4.96 4.116-2.118-1.387v1.556l7.078 4.237 7.068-4.237v-1.556L16.97 18.75z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDropbox);
export { ForwardRef as ReactComponent };